import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const logPageView = (page) => {
  axios.post(`${API_BASE_URL}/songs/page-view`, { page }).catch(() => {});
};

// Pobieranie tokenu bezpieczeństwa
export const getSecurityToken = async () => {
  try {
    console.log('[API] Requesting security token');
    const response = await axios.get(`${API_BASE_URL}/songs/security-token`);
    console.log('[API] Security token received');
    return response.data.token;
  } catch (error) {
    console.error('[API] Failed to get security token:', error);
    throw error.response?.data?.error || 'Failed to get security token';
  }
};

export const convertYouTubeToMp3 = async (url, onProgress) => {
  // Najpierw pobierz token bezpieczeństwa
  const token = await getSecurityToken();
  
  return new Promise((resolve, reject) => {
    const requestUrl = `${API_BASE_URL}/songs/convert?url=${encodeURIComponent(url)}&token=${token}`;
    console.log('[API] Opening SSE connection:', requestUrl);
    const eventSource = new EventSource(requestUrl);
    let settled = false;
    
    eventSource.onmessage = (event) => {
      console.log('[API] Message received:', event.data);
      try {
        const data = JSON.parse(event.data);
        console.log('[API] Parsed data:', data);
        
        if (data.type === 'progress' && onProgress) {
          console.log('[API] Progress event:', data);
          onProgress(data);
        } else if (data.type === 'complete') {
          console.log('[API] Conversion complete:', data);
          if (settled) return;
          settled = true;
          eventSource.close();
          resolve(data);
        } else if (data.type === 'error') {
          console.error('[API] Error received:', data.message);
          if (settled) return;
          settled = true;
          eventSource.close();
          reject(data.message);
        }
      } catch (error) {
        console.error('[API] Failed to parse response:', error);
        if (settled) return;
        settled = true;
        eventSource.close();
        reject('Failed to parse response');
      }
    };
    
    eventSource.onerror = (error) => {
      if (settled) return;
      console.error('[API] SSE connection error:', error);
      settled = true;
      eventSource.close();
      reject('Connection error');
    };
  });
};

export const getAllSongs = async () => {
  try {
    console.log('[API] Fetching all songs');
    const response = await axios.get(`${API_BASE_URL}/songs/list`);
    console.log('[API] Songs fetched:', response.data.data.length, 'songs');
    return response.data.data;
  } catch (error) {
    console.error('[API] Failed to fetch songs:', error);
    throw error.response?.data?.error || 'Failed to fetch songs';
  }
};

export const getDownloadUrl = (filename) => {
  const url = `${API_BASE_URL}/songs/download/${filename}`;
  console.log('[API] Generated download URL:', url);
  return url;
};

// Stats API helpers
const statsHeaders = (credentials) => ({
  Authorization: 'Basic ' + btoa(`${credentials.username}:${credentials.password}`)
});

export const fetchStatsDashboard = async (credentials) => {
  const response = await axios.get(`${API_BASE_URL}/songs/stats-api/dashboard`, {
    headers: statsHeaders(credentials),
    timeout: 60000
  });
  return response.data;
};

export const fetchStatsChart = async (credentials, type, hours = 24) => {
  const response = await axios.get(`${API_BASE_URL}/songs/stats-api/chart`, {
    params: { type, hours },
    headers: statsHeaders(credentials)
  });
  return response.data;
};

export const fetchStatsHot = async (credentials, period = 'day') => {
  const response = await axios.get(`${API_BASE_URL}/songs/stats-api/hot`, {
    params: { period },
    headers: statsHeaders(credentials)
  });
  return response.data;
};

export const fetchStatsHourly = async (credentials, date = null) => {
  const params = date ? { date } : {};
  const response = await axios.get(`${API_BASE_URL}/songs/stats-api/hourly`, {
    params,
    headers: statsHeaders(credentials)
  });
  return response.data;
};
